export default __webpack_public_path__ + "static/media/twitter.1fb09cc7.svg";